import { Link } from 'react-router-dom';
import './ComicCard.css';

function ComicCard({ type = "album", data })
{
   const PLACEHOLDER = 'https://www.flaggingdirect.com/images/No-Image-Placeholder.png';
   // if series, use series cover if available, else first album cover, if album, use album cover
   // Determine card properties based on type
   const cardConfig = type === 'serie' ? {
      url: `/serie/${data.slug}`,
      className: 'serie-card',
      imagePath:  data.cover || data.firstAlbum?.dossier
         ? `${process.env.REACT_APP_API_URL}/images/${data.firstAlbum?.dossier}/page-001.webp`
         : PLACEHOLDER,
      title: data.nom,
      subtitle: `${data.albumCount} album${data.albumCount > 1 ? 's' : ''}`
   } :
      {
         url: `/album/${data.dossier}`,
         className: 'album',
         imagePath:  `${process.env.REACT_APP_API_URL}/images/${data.dossier}/page-001.webp`,
         title: data.titre,
         subtitle: data.serieName
      };

   return (
      <Link to={ cardConfig.url } className={ `card-base ${cardConfig.className}` }>
         <img
            src={ cardConfig.imagePath }
            alt={ cardConfig.title }
            onError={ e => { e.target.src = PLACEHOLDER }}
         />
         <h3>{ cardConfig.title }</h3>
         <p>{ cardConfig.subtitle }</p>
      </Link>
   );
}

export default ComicCard;